// Fields we always want in each record
// eslint-disable-next-line import/prefer-default-export
export const GLOBAL_FIELDS = [
  'raceth',
  'racethd',
  'racethdimmigsex',
  'immig',
  'sex',
  'year',
  'GEO_NAME',
  'GEOGRAPHY_NAME',
  'geo_code_long',
  'unique_id_long',
];
